module.exports = __webpack_public_path__ + "img/home-educacao.8ac07f60.svg";